import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  AuthenticationClient,
  hydrateEhrAuthentication,
} from '../features/authentication/slice/authenticationSlice'
import {
  invalidateAuthenticatedContext,
  loadAuthenticatedContext,
} from '../features/authenticated-context/authenticatedContextSlice'
import { EhrLaunchClient } from '../features/ehr-launch/ehrLaunchSlice'
import { isEhrAuthSession } from '../features/ehr-launch/ehrLaunchStorage'
import { setOrganizationAdmin } from '../features/organization-admin/organizationAdminSlice'
import type { AppDispatch } from './store'
import { establishAuthenticatedProvider } from '../features/authentication/slice/authenticatedProviderSlice'
import { EhrAcquisitionOrigin } from '../features/ehr-launch/ehrPatientAcquisitionActions'
import { establishEhrLaunch } from '../features/ehr-launch/ehrPatientAcquisitionSlice'

export const establishEhrAuthenticatedContext = createAsyncThunk(
  'app/establish_ehr_authenticated_context',
  async ({ origin = 'restoring' }: { origin?: EhrAcquisitionOrigin } = {}, { dispatch }) => {
    const appDispatch = dispatch as AppDispatch
    const bootstrap = await dispatch(EhrLaunchClient.Bootstrap()).unwrap()
    appDispatch(establishEhrLaunch(bootstrap.launchInstanceId, origin))
    dispatch(establishAuthenticatedProvider('ehr'))
    dispatch(setOrganizationAdmin(null))
    dispatch(
      hydrateEhrAuthentication({
        userId: bootstrap.userId,
        permissions: bootstrap.permissions ?? [],
      })
    )
    return await appDispatch(loadAuthenticatedContext())
  }
)

export const appDidFinishLaunching = createAsyncThunk(
  'app/did_finish_launching',
  async (_, { dispatch }) => {
    const appDispatch = dispatch as AppDispatch
    appDispatch(invalidateAuthenticatedContext())
    if (isEhrAuthSession()) {
      return await dispatch(establishEhrAuthenticatedContext({})).unwrap()
    } else {
      await dispatch(AuthenticationClient.Login()).unwrap()
    }

    return await appDispatch(loadAuthenticatedContext())
  }
)
